export function getCssVar(name: string): string {
  const rootValue = getComputedStyle(document.documentElement)
    .getPropertyValue(name)
    .trim();

  if (rootValue) return rootValue;

  const body = document.body;
  if (!body) return rootValue;

  return getComputedStyle(body)
    .getPropertyValue(name)
    .trim();
}